import _ from 'underscore';

type Status =
  | 'preparing'
  | 'executing'
  | 'complete'
  | 'failed'
  | 'cancelled'
  | 'complete_with_errors';

// A candidate named in a bulk action's outcome, with why they were skipped or warned about.
export type CandidateNote = { name: string; reason: string };

export type BulkAction = {
  id: number;
  name: string;
  status: Status;
  progress?: number;
  totalCount: number;
  failureCount?: number;
  // For actions that record per-candidate outcomes (the offer pipeline): why each skipped candidate fell out,
  // and warnings about candidates that went ahead anyway.
  skipped?: Array<CandidateNote>;
  warnings?: Array<CandidateNote>;
};

export function isUnresolved(bulkAction: BulkAction) {
  return bulkAction.status === 'executing' || bulkAction.status === 'preparing';
}

export function isResolved(bulkAction: BulkAction) {
  return !isUnresolved(bulkAction);
}

export function isDismissed(bulkAction: BulkAction, dismissed: Array<number>) {
  return dismissed.some((id) => bulkAction.id === id);
}

export function anyUnresolved(bulkActions: Array<BulkAction>) {
  return bulkActions.some((bulkAction) => isUnresolved(bulkAction));
}

export function allAcknowledged(
  bulkActions: Array<BulkAction>,
  acknowledged: Array<number>
) {
  return (
    _.difference(
      bulkActions.map((bulkAction) => bulkAction.id),
      acknowledged
    ).length === 0
  );
}
